import { render, staticRenderFns } from "./pubSearch.vue?vue&type=template&id=9964a454&scoped=true"
import script from "./pubSearch.vue?vue&type=script&lang=js"
export * from "./pubSearch.vue?vue&type=script&lang=js"
import style0 from "./pubSearch.vue?vue&type=style&index=0&id=9964a454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9964a454",
  null
  
)

export default component.exports